import React from "react";
import Image from "next/image";
import Link from "next/link";
import { CLMLinkPrimaryArrow } from "components/CLM/v3/Buttons";

const ContractsCard = ({
  image,
  iconBg,
  borderColor,
  title,
  description,
  contractsUrl,
}) => {
  return (
    <Link
      href={contractsUrl}
      className={`group h-full w-full flex flex-col gap-4 rounded-2xl border border-gray-200 transition-all duration-500 ease-in-out text-center overflow-hidden`}
    >
      <div
        className={`w-full flex items-center justify-center mx-auto bg-slate-50
        `}
      >
        {image && (
          <div className="h-[200px] w-full flex justify-center items-center">
            <Image
              src={image}
              alt={title}
              loading="lazy"
              width={100}
              height={100}
              className="w-auto h-full object-cover mx-auto p-6 "
            />
          </div>
        )}
      </div>
      <div className={`w-full flex flex-col gap-2 text-left px-6 pb-6`}>
        <h2 className="text-xl sm:text-2xl font-bold">{title}</h2>
        <p className="text-lg sm:text-xl text-gray-800">{description}</p>
        <div className="w-full mt-3 flex justify-start ">
          <CLMLinkPrimaryArrow
            buttonText={"View Contracts"}
            buttonUrl={contractsUrl}
          />
        </div>
      </div>
    </Link>
  );
};

export default ContractsCard;
